/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_OtherInputs */

const en_method_other = /** @type {(inputs: Method_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other`)
};

const he_method_other = /** @type {(inputs: Method_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אחר`)
};

/**
* | output |
* | --- |
* | "other" |
*
* @param {Method_OtherInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const method_other = /** @type {((inputs?: Method_OtherInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_OtherInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_method_other(inputs)
	return he_method_other(inputs)
});